import { createCrudSlice, createCrudSelectors } from './CrudRedux'

const entityTypesSlice = createCrudSlice({
  name: 'entityTypes',
})

export const EntityTypesActions = entityTypesSlice.actions

export const EntityTypesSelectors = {
  ...createCrudSelectors({ name: 'entityTypes' }),
  getIdByName: (name) => (state) => {
    const et = state.entityTypes.entityTypes.find((et) => et.name === name)
    return et && et._id
  },
}

export default entityTypesSlice.reducer
